import variableRecursive from './variable-recursive';

const regex = /#{.*?}/g;
const regexClear = /[#|{|}]/g;

const variables = (targets = '', data = []) => targets.map((target) => {
  const match = target.match(regex);
  let newTarget = target;

  if (match !== null) {
    match.forEach((key) => {
      const children = key.replace(regexClear, '');
      const replace = variableRecursive(children, data);

      if (replace) {
        newTarget = newTarget.replace(key, replace);
      } else {
        newTarget = newTarget.replace(key, '');
      }
    });
  }
  return newTarget;
});

export default variables;
